import { useLocation } from "react-router-dom";
import Layout from "../layouts/LayoutDefault.jsx";
import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import MainContainer from "../components/MainContainer.jsx";
import ContentContainer from "../components/ContentContainer.jsx";
import EventPost from "../components/event_page/EventPost.jsx";

const EventPage = () => {
  // Get the full pathname
  const location = useLocation();
  let pathname = location.pathname;

  // Remove trailing slash if it exists
  if (pathname.endsWith("/")) {
    pathname = pathname.slice(0, -1);
  }
  // Extract the event slug after 'events/'
  const eventSlug = pathname.split("/events/")[1];

  // Fetch Event data
  const { data: eventData } = MakeGetRequest({
    route: `events/${eventSlug}`,
    errorCodeRedirect: 404,
  });

  return (
    <>
      <Layout
        title={eventData?.event.name || "Evenemang"}
        description={
          eventData
            ? `${eventData.event.name} - ${eventData.event.location} den ${eventData.event.date}`
            : "Evenemang i Strängnäs kommun"
        }
      >
        {eventData ? (
          <>
            <MainContainer>
              <ContentContainer>
                <EventPost data={eventData} />
              </ContentContainer>
            </MainContainer>
          </>
        ) : (
          <MainContainer>
            <ContentContainer>
              <div className="text-center py-10">
                <h4 className="text-xl">Laddar evenemang...</h4>
              </div>
            </ContentContainer>
          </MainContainer>
        )}
      </Layout>
    </>
  );
};

export default EventPage;
